import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import useAuthenticatedAxios from '../auth/AuthenticatedAxios';
import { useAuth0 } from '@auth0/auth0-react';
import { jwtDecode } from "jwt-decode";
import { updateUserLanguage } from '../Socket/socket';
const SettingsContainer = styled.div`
    padding: 0;
    margin: 0;
`;

const SettingsSection = styled.div`
    background-color: transparent;
    padding: 0;
    margin: 0;
`;

const SettingItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`;

const Label = styled.label`
    color: #FFFFFF;
    margin-right: 15px;
    min-width: 150px;
`;

const Select = styled.select`
    background: linear-gradient(135deg, rgba(25, 30, 45, 0.9) 0%, rgba(30, 35, 50, 0.9) 100%);
    color: #FFFFFF;
    border: 1px solid rgba(99, 102, 241, 0.2);
    border-radius: 6px;
    padding: 12px;
    font-size: 1rem;
    width: 100%;
    backdrop-filter: blur(10px);
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: rgba(99, 102, 241, 0.5);
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
    }
    
    option {
        background-color: #1a1f2e;
    }
`;

const LanguageSelector = ({ language, onChange }) => {
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [languages, setLanguages] = useState([]);
    const authenticatedAxios = useAuthenticatedAxios();
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        try {
            const getLanguages = async () => {
                const response = await authenticatedAxios.get('/settings/languages');

                if (response.data && response.data.supportedLanguages && response.data.supportedLanguages.length > 0) {
                    setLanguages(response.data.supportedLanguages);
                }

                const myLanguage = await authenticatedAxios.get('/settings/language');

                if (myLanguage.data && myLanguage.data.language) {
                    setSelectedLanguage(myLanguage.data.language);
                }


            }
            getLanguages();
        } catch (error) {
            console.error("LanguageSelector: Error fetching languages from API:", error);
        }
    }, [authenticatedAxios]);

    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                if (language || selectedLanguage === language) {
                    setSelectedLanguage(language);
                } else {
                    // Fall back to token
                    const token = await getAccessTokenSilently();
                    const decodedToken = jwtDecode(token);
                    const preferredLanguage = decodedToken.preferred_language || 'en';
                    setSelectedLanguage(preferredLanguage);
                }
            } catch (error) {
                console.error('LanguageSelector: Error in language initialization:', error);
            }
        };

        fetchLanguages();
    }, [authenticatedAxios, getAccessTokenSilently, language]);

    const handleLanguageChange = async (e) => {
        const newLanguage = e.target.value;
        setSelectedLanguage(newLanguage);

        // Call parent component's onChange handler if provided
        if (onChange) {
            console.log("LanguageSelector: Calling parent onChange with:", newLanguage);
            onChange(newLanguage);
        }

        // Post language change to API
        try {
            const response = await authenticatedAxios.post(`/settings/language`, {
                language: newLanguage
            });
            updateUserLanguage(newLanguage);
        } catch (error) {
            console.error('LanguageSelector: Error updating language:', error);
        }
    };

    return (
        <SettingsContainer>
            <SettingsSection>
                <SettingItem>
                    <Select
                        value={selectedLanguage}
                        onChange={handleLanguageChange}
                    >
                        {languages.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                                {lang.name}
                            </option>
                        ))}
                    </Select>
                </SettingItem>
            </SettingsSection>
        </SettingsContainer>
    );
};

export default LanguageSelector;
